export const printCloudTicket = async (
  order,
  total,
  appliedPayments,
  property,
  deviceConfig,
  selectedRevenue,
  selectedSpace,
  chequeSeleccionado,
  currentUser,
  printerConfig
) => {
  try {
    // Validar configuración (puede incluir URL de API o token)
    if (!printerConfig.CloudAPI) {
      throw new Error("Configuración de impresora Cloud incompleta");
    }

    // Construir el contenido del ticket
    const ticketContent = {
      property,
      device: deviceConfig.name,
      revenue: selectedRevenue?.name || "N/A",
      table: selectedSpace?.name || "N/A",
      cheque: chequeSeleccionado || "N/A",
      user: currentUser?.nombre || "N/A",
      items: order.map((item) => ({
        name: item.name,
        quantity: item.quantity,
        price: item.price * item.quantity,
      })),
      total,
      payments: appliedPayments.map((p) => ({
        method: p.method.name,
        amount: p.amount,
      })),
      timestamp: new Date().toISOString(),
    };

    // Simulación de envío a la impresora en la nube
    console.log(`Enviando a impresora Cloud via ${printerConfig.CloudAPI}`);
    console.log("Contenido del ticket:", ticketContent);

    // Aquí iría la lógica real para enviar a la API de la nube
    // Ejemplo: await fetch(printerConfig.CloudAPI, { method: "POST", body: JSON.stringify(ticketContent) });

    return { success: true, message: "Ticket enviado a la impresora Cloud" };
  } catch (error) {
    console.error("Error al imprimir en impresora Cloud:", error);
    return { success: false, message: `Error al imprimir: ${error.message}` };
  }
};